<template>
  <el-drawer
    :visible="visible" :modal="false" direction="btt"
    :withHeader="false" size="100%" custom-class="no-animation">
    <rhcn-drawer
      title="message.permission.addRole"
      description="message.permission.rolePermissionTip"
      class="role-drawer"
      @on-close="onClose"
    >
      <div class="role-modal-wrapper">
        <el-form class="form-wrapper" :model="form" ref="formRef" :rules="formRules" label-position="top">
          <el-form-item :label="$t('message.permission.roleName')" prop="roleName">
            <el-input v-model="form.roleName" :placeholder="$t('message.validator.input', { input: $t('message.permission.roleName') })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.permission.rolePermission')">
            <role-tree :list.sync="resourceIdArr"></role-tree>
          </el-form-item>
          <div class="margin-top-25 margin-bottom-25">
            <el-button
              style="width: 100%"
              type="primary"
              :loading="requesting"
              @click="handleSubmit">
              {{ $t("message.common.submit") }}
            </el-button>
          </div>
        </el-form>
      </div>
    </rhcn-drawer>
  </el-drawer>
</template>

<script>
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { saveRole } from '@/views/account/permission/api/role';
import RoleTree from '@/views/account/permission/role/role-tree/index.vue';

export default {
  components: {
    RhcnDrawer,
    RoleTree,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requesting: false,
      form: {},
      formRules: {
        roleName: [{ required: true, message: this.$t('message.validator.input', { input: this.$t('message.permission.roleName') }), trigger: 'blur' }],
      },
      resourceIdArr: [],
    };
  },
  methods: {
    onClose() {
      this.form = {};
      this.resourceIdArr = [];
      this.$emit('close');
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if (!this.resourceIdArr.length) {
            this.$message.error(this.$t('message.validator.select', { select: this.$t('message.permission.permission') }));
            return;
          }
          const roleData = {
            roleName: this.form.roleName.trim(),
            resourceId: this.resourceIdArr,
          };
          this.requesting = true;
          try {
            await saveRole(roleData);
            ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
            this.onClose();
            this.$emit('refresh');
          } catch (err) {
          }
          this.requesting = false;
        } else {
          this.$nextTick(() => {
            const errorDom = document.querySelector('.is-error');
            if (errorDom) {
              errorDom.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-modal-wrapper {
  .form-wrapper {
    width: 730px;
    margin: 30px auto;
  }
}
</style>
<style lang="scss">
.role-drawer {
  .text-wrapper {
    width: 730px;
  }
}
</style>
